var React = require('react');

function VideoLibrary (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5 19a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19zm0-2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zM7.8 5.6l4.667 3.5a.5.5 0 0 1 0 .8L7.8 13.4A.5.5 0 0 1 7 13V6a.5.5 0 0 1 .8-.4z","fill":"#424242","fillRule":"evenodd"}));
}

VideoLibrary.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19"};

module.exports = VideoLibrary;

VideoLibrary.default = VideoLibrary;
